import { ASSET_TYPE_PHONE, ASSET_TYPE_VEHICLE } from '../constants/asset';
import { ASSET_TYPE_CONTAINER } from './../constants/asset';
import { ClientCore } from './client';
import { Device, SecondaryDevice } from './device';
import { GorilaDriver } from './drivers';
import { CurrentFence } from './fence';
import { SubClientCore } from './subClient';
import { Vehicle } from './vehicle';

export type AssetType = typeof ASSET_TYPE_VEHICLE | typeof ASSET_TYPE_CONTAINER | typeof ASSET_TYPE_PHONE;

export interface AssetCore {
  _id: string;
  assetType: AssetType;
  client?: ClientCore;
  subClient?: SubClientCore;
  container?: {
    identifier: string;
  };
  device?: Device | string;
  inJourney: boolean;
  journeyId: string;
  label?: string;
  vehicle?: Vehicle;
  secondaries?: SecondaryDevice[];
}

export interface Asset extends AssetCore {
  created: string;
  lastModified: string;
  deleted: boolean;
  monitoring: boolean;
  isEngineStall?: boolean;
  isDoorOpen?: boolean;
  gbConsumed?: number;
  gbAssetConsumption?: number;
  deliveryFence?: CurrentFence;
  geoFence?: CurrentFence;
  channels?: number;
  gorilaDriver?: GorilaDriver;
}

export interface MinimalApiAsset {
  assetId: string;
  clientId: string;
  subClientId: string;
}

export enum FuelType {
  magna = 'magna',
  premium = 'premium',
  diesel = 'diesel',
  lpGas = 'lp_gas',
  cnv = 'cnv',
  electric = 'electric',
  hydrogen = 'hydrogen',
}
